module.exports = __webpack_public_path__ + "img/Wp_2012.a09817e7.png";